<template>
  <div class="gray-box">
    <div class="search-box">

      <div class="search-li">
        <div class="qz-search-wrap">
          <van-search
              v-model="keywords"
              placeholder="搜索"
              shape="round"
              @search="onSearch"
          >
            <!--        <div slot="action" @click="onSearch(keywords)" style="padding:0 10px">搜索</div>-->
            <div class="search-tip" slot="left-icon" v-if="checkName">{{ checkName }} |</div>
            <div class="search-content-right" slot="right-icon" @click="onSearch(keywords)">
              <div class="search-button flex-center">搜索</div>
            </div>
          </van-search>
        </div>

        <div class="row3" v-if="!defaultSign">
          <div :key="index" :class="checkSign == item.sign ? 'row3-li row3-li-active' : 'row3-li'"
               v-show="item.num > 0 || !item.sign"
               v-for="(item, index) in columnList" @click="onChecked(item)">
            <img :src="require('../../../assets/images/cha/'+item.icon+'.png')"/>
            <!--            <img @click="onChecked('赛事活动')" src="../../../assets/images/cha/icon-sc.png"/>-->
            <div :class="item.sign ? 'row-tip' : 'row-tip row-tips'">{{ item.name }}</div>
            <div class="row-num">({{ item.num }})</div>
          </div>
        </div>
      </div>

      <!--<input class="test" autofocus="autofocus" />-->
      <!--        <div v-if="!keywords && history_list.length>0" class="search-default">-->
      <!--            <h3 class="title">搜索历史 <em @click="emptyHistory" style="float: right ; margin-right: 20px">清除</em></h3>-->

      <!--            <div class="cf"></div>-->
      <!--            <ul class="result cf">-->
      <!--                <li v-for="(item,index) in history_list" class="item" :key="index" @click="onSearch(item) ">{{item}}</li>-->
      <!--            </ul>-->
      <!--            <div class="cf"></div>-->
      <!--        </div>-->
      <!--        <div class="" v-if="emptyShow">-->
      <!--            <van-empty style="margin: 10px auto" description="暂无结果" />-->
      <!--        </div>-->


      <div class="search-result" v-if="checkSign">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="sai-itmes sai-box" :key="index" v-for="(item,index) in list" v-if="checkSign == 'sai'">
          <div class="items-top1">
            <div
                class="train-items-top show-two-row"
                :style="'background-image: linear-gradient(to right, #'+item.color[0]+' , #'+item.color[1]+');'"
            >
              <div v-if="item.is_online==1" class="sai-type-tip">线上</div>
              <div v-else class="sai-type-tip offline">线下</div>
              <div class="train-items-top-city">{{ item.location }}</div>
              <div class="train-items-top-time">{{ item.saidate_str }} ~ {{ item.saidate_end_str }}</div>
            </div>

            <div style="text-align: center;margin-top: .1rem">
              <span class="info-status-0" v-if="item.status==1">未开始</span>
              <span class="info-status-1" v-else-if="item.status==2">正在报名</span>
              <span class="info-status-0" v-else-if="item.status==3">报名结束</span>
              <span class="info-status-1" v-else-if="item.status==4">正在比赛</span>
              <span class="info-status-0" v-else-if="item.status==5">已结束</span>
              <!--<span class="info-data" style="max-width:0.75rem">{{item.saidate_str}}</span>-->
              <!--<span class="info-address" style="flex:1">{{item.location}}</span>-->
            </div>
          </div>

          <div style="flex:1;" class="sai-info-box">
            <p class="sai-title show-two-row">{{ item.name }}</p>
            <div class="sai-info" v-if="false">
              <span class="info-status-0" v-if="item.status==1">·未开始</span>
              <span class="info-status-1" v-else-if="item.status==2">·正在报名</span>
              <span class="info-status-0" v-else-if="item.status==3">·报名结束</span>
              <span class="info-status-1" v-else-if="item.status==4">·正在比赛</span>
              <span class="info-status-0" v-else-if="item.status==5">·已结束</span>
              <!--<span class="info-data" style="max-width:0.75rem">{{item.saidate_str}}</span>-->
              <!--<span class="info-address" style="flex:1">{{item.location}}</span>-->
            </div>
            <div class="sai-info">
              <!-- <div class="info-address" v-if="item.status==5" style="flex:1"> -->
              <!-- 共有来自 -->
              <!-- {{item.city_count}} -->
              <!-- 个地市的 -->
              <!-- {{item.duiwu_count}} -->
              <!-- 支队伍 -->
              <!-- {{item.member_count}} -->
              <!-- 人参加 -->
              <!-- </div> -->
            </div>
            <div class="items-btn">
              <div
                  class="sai-join"
                  v-if="item.status<3"
                  v-rblink="{name:'ISaiApplyFormStep1',query:{saiqu_id:item.id}}"
              >报名
              </div>
              <div
                  class="sai-into"
                  v-if="item.status!=1"
                  v-rblink="{name:'ActivityActivity',query:{id:item.activity_id}}"
              >进入
              </div>
            </div>
          </div>
          
        </div>

        <div class="new-box" v-if="checkSign == 'news' || checkSign == 'jwjl'">
          <div v-for="(row,i) in list" :key="i" v-rblink="{name:'NewsDetail',query:{id:row.id }}" >
            <!-- 无图 style==1 -->
            <NewsItem1 :row="row" v-if="row.pics.length==0"></NewsItem1>
            <!-- 有图 style==2 -->
            <NewsItem2 :row="row" v-if="row.pics.length==1"></NewsItem2>
            <!-- 视频 style==3 -->
            <NewsItem3 v-if="false"></NewsItem3>
            <!-- 多图 style==4 -->
            <NewsItem4 :row="row" v-if="row.pics.length>1"></NewsItem4>
                  
          </div>
        </div>

        <div class="member-box" v-if="checkSign == 'hyjy'">
          <div class="right-li flex-start" v-for="(row,i) in list" :key="i" v-rblink="{name:'NewsDetail',query:{id:row.id }}">
            <div class="right-li-img">
              <!--              <img src="../../../assets/images/other/bg-shangwuzhaoshang.png" alt="">-->
              <img :src="row.pic_url" alt="">
              <!--              <div>加我企业微信</div>-->
            </div>
            <!--            <div class="right-li-line"></div>-->
            <div class="right-li-user">
              <div class="right-user-one">
                <div class="right-user-label">标题</div>
                <div class="right-user-value">{{ row.title }}</div>
              </div>
              <div class="right-user-one">
                <div class="right-user-label">描述</div>
                <div class="right-user-value">{{ row.desc }}</div>
              </div>
              <!--              <div class="right-user-one">-->
              <!--                <div class="right-user-label">职务</div>-->
              <!--                <div class="right-user-value">河北省负责人</div>-->
              <!--              </div>-->
            </div>

            <!--            <div class="right-li-sign right-li-sign-province">河北省</div>-->
          </div>
        </div>

        <div class="main-bottom-box" v-if="checkSign == 'goods'">
          <goodsItem v-for="(goods,index) in list" :row="goods">
          </goodsItem>
        </div>

        <div class="main-bottom-box" v-if="checkSign == 'huiyi' || checkSign == 'qcxj'">
          <peiItem v-for="(huiyi,index) in list" :row="huiyi"></peiItem>
        </div>

        </van-list>

      </div>

      <div class="search-result" v-else>
        <div class="search-group-li" v-for="group in list" :key="group.sign">
          <div class="search-group-title" v-if="group.list.length > 0">{{group.name}}</div>
          <div class="search-group-content">
            <div class="sai-itmes sai-box" v-if="group.sign == 'sai'"  v-for="item in group.list">
              <div class="items-top1">
                <div
                    class="train-items-top show-two-row"
                    :style="'background-image: linear-gradient(to right, #'+item.color[0]+' , #'+item.color[1]+');'"
                >
                  <div v-if="item.is_online==1" class="sai-type-tip">线上</div>
                  <div v-else class="sai-type-tip offline">线下</div>
                  <div class="train-items-top-city">{{ item.location }}</div>
                  <div class="train-items-top-time">{{ item.saidate_str }} ~ {{ item.saidate_end_str }}</div>
                </div>

                <div style="text-align: center;margin-top: .1rem">
                  <span class="info-status-0" v-if="item.status==1">未开始</span>
                  <span class="info-status-1" v-else-if="item.status==2">正在报名</span>
                  <span class="info-status-0" v-else-if="item.status==3">报名结束</span>
                  <span class="info-status-1" v-else-if="item.status==4">正在比赛</span>
                  <span class="info-status-0" v-else-if="item.status==5">已结束</span>
                  <!--<span class="info-data" style="max-width:0.75rem">{{item.saidate_str}}</span>-->
                  <!--<span class="info-address" style="flex:1">{{item.location}}</span>-->
                </div>
              </div>

              <div style="flex:1;" class="sai-info-box">
                <p class="sai-title show-two-row">{{ item.name }}</p>
                <div class="sai-info" v-if="false">
                  <span class="info-status-0" v-if="item.status==1">·未开始</span>
                  <span class="info-status-1" v-else-if="item.status==2">·正在报名</span>
                  <span class="info-status-0" v-else-if="item.status==3">·报名结束</span>
                  <span class="info-status-1" v-else-if="item.status==4">·正在比赛</span>
                  <span class="info-status-0" v-else-if="item.status==5">·已结束</span>
                  <!--<span class="info-data" style="max-width:0.75rem">{{item.saidate_str}}</span>-->
                  <!--<span class="info-address" style="flex:1">{{item.location}}</span>-->
                </div>
                <div class="sai-info">
                  <!-- <div class="info-address" v-if="item.status==5" style="flex:1"> -->
                  <!-- 共有来自 -->
                  <!-- {{item.city_count}} -->
                  <!-- 个地市的 -->
                  <!-- {{item.duiwu_count}} -->
                  <!-- 支队伍 -->
                  <!-- {{item.member_count}} -->
                  <!-- 人参加 -->
                  <!-- </div> -->
                </div>
                <div class="items-btn">
                  <div
                      class="sai-join"
                      v-if="item.status<3"
                      v-rblink="{name:'ISaiApplyFormStep1',query:{saiqu_id:item.id}}"
                  >报名
                  </div>
                  <div
                      class="sai-into"
                      v-if="item.status!=1"
                      v-rblink="{name:'ActivityActivity',query:{id:item.activity_id}}"
                  >进入
                  </div>
                </div>
              </div>
               
            </div>
            

            <div class="new-box" v-if="group.sign == 'news' || group.sign == 'jwjl'">
              <div v-for="(row,i) in group.list" :key="i" v-rblink="{name:'NewsDetail',query:{id:row.id }}" >
                <!-- 无图 style==1 -->
                <NewsItem1 :row="row" v-if="row.pics.length==0"></NewsItem1>
                <!-- 有图 style==2 -->
                <NewsItem2 :row="row" v-if="row.pics.length==1"></NewsItem2>
                <!-- 视频 style==3 -->
                <NewsItem3 v-if="false"></NewsItem3>
                <!-- 多图 style==4 -->
                <NewsItem4 :row="row" v-if="row.pics.length>1"></NewsItem4>
              </div>
            </div>

            <div class="member-box" v-if="group.sign == 'hyjy'">
              <div class="right-li flex-start" v-for="(row,i) in group.list" :key="i" v-rblink="{name:'NewsDetail',query:{id:row.id }}">
                <div class="right-li-img">
                  <!--              <img src="../../../assets/images/other/bg-shangwuzhaoshang.png" alt="">-->
                  <img :src="row.pic_url" alt="">
                  <!--              <div>加我企业微信</div>-->
                </div>
                <!--            <div class="right-li-line"></div>-->
                <div class="right-li-user">
                  <div class="right-user-one">
                    <div class="right-user-label">标题</div>
                    <div class="right-user-value">{{ row.title }}</div>
                  </div>
                  <div class="right-user-one">
                    <div class="right-user-label">描述</div>
                    <div class="right-user-value">{{ row.desc }}</div>
                  </div>
                  <!--              <div class="right-user-one">-->
                  <!--                <div class="right-user-label">职务</div>-->
                  <!--                <div class="right-user-value">河北省负责人</div>-->
                  <!--              </div>-->
                </div>

                <!--            <div class="right-li-sign right-li-sign-province">河北省</div>-->
              </div>
            </div>

            <div class="main-bottom-box" v-if="group.sign == 'goods'">
              <goodsItem v-for="(goods,index) in group.list" :row="goods">
              </goodsItem>
            </div>

            <div class="main-bottom-box" v-if="group.sign == 'huiyi' || group.sign == 'qcxj'">
              <peiItem v-for="(huiyi,index) in group.list" :row="huiyi"></peiItem>
            </div>
          </div>
          <div style="text-align:center" v-show="group.list.length>0">
           <van-button
                         style=""
                        size="normal" round   @click="onChecked(group)">查看更多有关[{{keywords}}]的{{group.name}}</van-button>
          
          </div>
        </div>


      </div>
    </div>
  </div>

</template>
<style scoped>
.search-group-title {
  margin-left: .2rem;
  margin-bottom: .1rem;
  margin-top: .1rem;
  font-size: .28rem;
  font-weight: 700;
}
/*****hy**/
.row-box {
  display: flex;
  justify-content: flex-start;
}

.row-tips {
  margin-left: .2rem;
}
.right-user-one {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /*margin-top: .22rem;*/
}

.right-user-label {
  margin-right: .2rem;
  min-width: 24px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.right-li-user {
  margin-left: .2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 46px;
}

.right-user-value {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
}

.row-left {
  height: 100vh;
  width: 105px;
  min-width: 105px;
  background: #F5F5F5;
  text-align: center;
  overflow-y: scroll;
}

.left-li-active {
  background: #FFFFFF;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #F7B500;
}

.row-right {
  height: 100vh;
  width: 100%;
  background: #fff;
  overflow-y: scroll;
}

.right-li-img img {
  width: 46px;
  height: 46px;
  border-radius: 100%;
  /*box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);*/
}

.left-li {
  height: 50px;
  line-height: 50px;
}

.right-li {
  margin: .2rem .2rem 0;
  box-shadow: 0px 1px 5px 1px rgba(0,0,0,0.05);
  padding: .3rem .2rem;
  position: relative;
  background: #fff;
  border-radius: 4px;
}

.right-li-sign-province {
  background: linear-gradient(133deg, #FA6400 0%, #FD9D00 100%);
}

.right-li-sign-city {
  background: linear-gradient(130deg, #7798FF 0%, #D4E1FF 100%);
}

.right-li-sign {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 8px 4px 8px 0px;
  color: #fff;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  padding: 2px 10px;
}

.right-li-img {
  text-align: center;
  padding: 5px;
}

.right-li-img div {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.right-li-line {
  width: 1px;
  height: 62px;
  background: #E5E5E5;
  margin: 0 .3rem 0 .2rem;
}
/******sai****/
.sai-box {
  margin: 0 .2rem;
}
.train-items-top-city {
  font-size: .32rem;
  color: #fff;
  overflow: hidden;
  padding-top: .05rem;
  /*height: 0.88rem;*/
}

.train-items-top-time {
  font-size: .28rem;
  color: #fff;
  padding-bottom: .1rem;
}

.sai-type-tip {
  width: 1rem;
  color: #fff;
  font-size: .24rem;
  background: linear-gradient(
      140deg, rgb(253, 157, 0) 0%, rgb(250, 100, 0) 100%);
  border-radius: 10px 0px 10px 0px;
  /*position: absolute;*/
  /*top: 0;*/
}

.offline {
  background: linear-gradient(
      140deg, #44D7B6 0%, #44D7B6 100%);
}

.train-items-top {
  /* flex: 1; */
  /*position: relative;*/
  width: 1.9rem;
  /*height: 1.3rem;*/
  border-radius: 10px;
  display: flex;
  text-align: center;
  /*align-items: baseline;*/
  flex-direction: column;
  justify-content: center;
  /*padding-left: 0.1rem;*/
  margin-right: 0.1rem;
}
.sai-info-box {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  /* height: 1rem; */
}

.sai-info-box .items-btn {
  display: flex;
}

.sai-into {
  width: 1rem;
  height: 0.5rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 14px;
  border: 1px solid rgba(231, 46, 41, 1);
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(230, 56, 56, 1);
  line-height: 0.5rem;
  text-align: center;
}

.sai-join {
  width: 1rem;
  height: 0.5rem;
  background: linear-gradient(
      130deg,
      rgba(243, 95, 95, 1) 0%,
      rgba(228, 49, 49, 1) 100%
  );
  border-radius: 14px;
  font-size: 12px;
  margin-right: 6px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.5rem;
  text-align: center;
}

.info-address,
.info-data {
  height: 16px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 16px;
  overflow: hidden;
}
.info-status-0 {
  height: 16px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  color: rgba(250, 173, 20, 1);
  line-height: 16px;
  /*max-width: 1.1rem;*/
  overflow: hidden;
}

.info-status-1 {
  height: 16px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 700;
  color: #2e8404;
  line-height: 16px;
}

.sai-title {
  /*height: 21px;*/
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  margin-bottom: .2rem;
  color: #333333;
}

.sai-info {
  display: flex;
}

.sai-info span {
  margin-right: 10px;
}

.sai-img {
  width: 1rem;
  height: 1rem;
  display: block;
  margin-right: 10px;
}

.sai-data-items {
  width: 7.1rem;
  margin: 0 auto;
  padding-bottom: 10px;
}

.sai-data-year {
  padding: .2rem .3rem;
  margin-bottom: .2rem;
  border-radius: .1rem;
  background: #fff;
}

.sai-itmes {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  padding: 15px 13px;
  align-items: flex-start;
  background: #fff;
  margin-bottom: .2rem;
  border-radius: 10px;
}

.sai-items-box {
  width: 7.1rem;
  /* height:323px; */
  /*background: rgba(255, 255, 255, 1);*/
  /*border-radius: 10px;*/
  padding: 10px 0;
}




.search-result {
  /*margin: 0 .2rem;*/
}

.gray-back {
  background: #efefef;
}



.gray-box {
  background: #F8F8F8;
  min-height: 100vh;
}

.search-box {
  padding: .2rem 0;
}

.search-li {
  background: #FFFFFF;
  border-radius: 12px;
  margin: 0 .2rem .2rem;
}

.qz-search-wrap .search-tip {
  margin-left: 5px;
}

.qz-search-wrap .van-search {
  padding: .3rem .2rem;
  border-radius: 12px;
}

.qz-search-wrap .van-search__content {
  border: 1px solid #FA6400;
  background: #fff;
  color: #C8C9CC;
}

.qz-search-wrap >>> .van-icon {
  color: #C8C9CC;
}

.qz-search-wrap .van-cell {
  padding: 2px 8px 2px 0;
  line-height: 30px;
}

.qz-search-wrap >>> .van-field__body input::-webkit-input-placeholder {
  color: #C8C9CC;
}

.qz-search-wrap >>> .van-field__right-icon {
  padding: 0 2px;
}

.qz-search-wrap .search-content-right {
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
}

.qz-search-wrap .search-content-right .search-button {
  background: linear-gradient(133deg, #FD9D00 0%, #FA6400 100%);
  border-radius: 50px;
  width: 52px;
  height: 30px;
}

.recommend-box {
  width: 100%;
  height: 192px;
  background: url('../../../assets/images/cha/bg-neirongtuijian.png') no-repeat center;
  background-size: 100%;
  position: relative;
  margin-top: .3rem;
}

.main-bottom-box {
  display: flex;
  justify-content: space-between;
  width: 7.1rem;
  margin: 0 auto;
  flex-wrap: wrap;
  /*padding-top: 50px;*/
}

.row3 {
  display: flex;
  flex-wrap: wrap;
  /*margin: 0 .2rem;*/
  margin-left: .1rem;
  padding-bottom: .2rem;
}

.row3 img {
  /*width: 100%;*/
  width: .4rem;
  height: .4rem;
}

.row-tip {
  font-size: .26rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  /*margin-left: .05rem;*/
}

.row-num {
  font-size: .26rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #F7B500;
}

.row3-li {
  /*width: calc(33% - .2rem);*/
  width: 2.2rem;
  box-sizing: border-box;
  background: #F7F8FA;
  border-radius: 18px;
  padding: .14rem .08rem .14rem .12rem;
  margin-right: .15rem;
  margin-bottom: .15rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.row3-li-active {
  border: 1px solid #F7B500;
  box-sizing: border-box;
}

.row3-li:nth-child(3n) {
  margin-right: 0;
}

.search-default {
  background-color: #fff;
}

.search-default .title {
  line-height: 38px;
  padding-left: 13px;
  font-size: 14px;
  color: #999;
  font-weight: normal;
}

.search-default .result {
}

.search-default .result .item {
  box-sizing: border-box;
  width: 50%;
  line-height: 36px;
  float: left;
  padding-left: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #666;
}

.cf {
  clear: both;
}

.equalblock-warp {
  width: 100%;
  display: flex;
  font-size: 0;
}

.equalblock-item {
  flex: 1;
}

.equalblock-pic {
  width: 100%;
  min-height: 30px;
}

span.s {
  width: 1px;
  background: rebeccapurple;
}

.equalblock-item .equalblock-title {
  font-size: 14px;
  display: inline-block;
  width: 100%;
  text-align: center;
  padding: 5px 0;
}
</style>

<script>
import {
  Search,
  Cell, CellGroup, Field, Button, Empty, Toast
} from 'vant';
import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";
import saiItem from "@/components/index/SaiItem.vue";
import goodsItem from "@/components/index/GoodsItem.vue";
import newsItem from "@/components/index/NewsItem.vue";
import peiItem from "@/components/index/PeiItem.vue";
//    import $ from  'jquery';
export default {
  name: 'ChaSearchAllResult',
  components: {
    [Search.name]: Search,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Empty.name]: Empty,
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
    saiItem,
    goodsItem,
    newsItem,
    peiItem
  },
  data: function () {
    return {
      keywords: '',
      hot_list: [],
      list: [],
      emptyShow: false,
      isLoading: false,
      loading: false,
      finished: false,
      history_list: [],

      pageListRow: {
        sai: [],
        huiyi: [],
        news: [],
        goods: [],
      },

      params: {
        pageNo: 1,
        pageSize: 10,
        sign: '',
        keywords: ''
      },

      columnList: [
        {name: '全部', icon: 'icon-all', num: 0, sign: ''},
        {name: '赛事活动', icon: 'icon-sshd', num: 0, sign: 'sai'},
        {name: '新闻资讯', icon: 'icon-xwzz', num: 0, sign: 'news'},
        {name: '培训会议', icon: 'icon-pxhy', num: 0, sign: 'huiyi'},
        {name: '七彩星级', icon: 'icon-qcxj', num: 0, sign: 'qcxj'},
        {name: '境外交流', icon: 'icon-jwjl', num: 0, sign: 'jwjl'},
        {name: '行业精英', icon: 'icon-hyjy', num: 0, sign: 'hyjy'},
        {name: '积分商城', icon: 'icon-sc', num: 0, sign: 'goods'},
      ],

      countList: [],
      defaultSign: '',
      checkSign: '',
      checkName: '',
    }
  },
  watch: {
    // keywords(value) {
    //   if (!value) {
    //     return false;
    //   }
    // }
  },
  filter: {},
  created() {
    document.title = "查询";
    let that = this;
    let sign = that.$route.query.sign
    let keywords = that.$route.query.keywords

    if(sign) {
      this.defaultSign = this.checkSign = sign
    }

    if (keywords) {
      this.keywords = keywords
      this.fetch()
    }

    this.getCheckName(sign)
  },
  mounted() {
  },
  methods: {
    fetch() {
      let that = this;
      console.log('that.checkSign', that.checkSign)

      that.loading = true
      that.params.keywords = that.keywords
      that.params.sign = that.checkSign
      this.$api.get(
          "/api/cha/searchAll", that.params, res => {
            that.countList = res.data.count_list;
            that.checkSign = res.data.sign

            if(that.checkSign) {
              that.loading = false;

              if (res.data.currentpage == 1) {
                that.isLoading = false;
                that.list = res.data.list;

              } else {
                that.list = that.list.concat(res.data.list);
              }

              if (res.data.list.length == 0) {
                that.finished = true;
              }
              that.params.pageNo += 1;
            }  else {
              that.list = res.data.list;
            }

            that.onNumCalc()
          });
    },

    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");


      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      } else {
        this.loading = false
      }
    },

    onNumCalc() {
      let that = this,
          defaultList = that.columnList

      let count = 0
      defaultList.map(column => {
        that.countList.map(row => {
          if(column.sign == row.sign) {
            column.num = row.count
          }

          if(!column.sign) {
            count+=row.count
            column.num = count
          }
        })
      })
    },

    onSearch(val) {
      console.log(val);
      val = (val + '').trim();
      this.keywords = val;

      if (!val) {
        Toast('请输入关键词')
        return
      }

      // let search_history = JSON.parse(localStorage.getItem('search_history') || '[]');
      // if (search_history.indexOf(val) == -1) {
      //   search_history.push(val);
      //   localStorage.setItem('search_history', JSON.stringify(search_history));
      //   this.history_list = search_history;
      // }
      this.loading = true
      this.finished = false
      this.list = []
      this.params.pageNo = 1
      this.fetch();
    },
    emptyHistory() {
      this.history_list = [];
      localStorage.setItem('search_history', '[]');
    },

    onChecked(item) {
      let that = this
      that.list = []
      that.checkSign = item.sign

      if (!that.keywords) {
        Toast('请输入关键词')
        return
      }
      that.params.pageNo = 1;
      if(that.checkSign) {
        that.loading = true
        that.finished = false;
      }
      that.fetch()
    },

    getCheckName(sign) {
      let name = ''
      switch (sign) {
        case 'sai':
          name = '赛事活动'
          break;
        case 'news':
          name = '新闻资讯'
          break;
        case 'huiyi':
          name = '培训会议'
          break;
        case 'qcxj':
          name = '七彩星级'
          break;
        case 'jwjl':
          name = '境外交流'
          break;
        case 'hyjy':
          name = '行业精英'
          break;
        case 'goods':
          name = '商品'
          break;
      }
      this.checkName = name
    },
  }
}
</script>



// WEBPACK FOOTER //
// SearchAllResult.vue?4b64e4e8